// import find from 'lodash/find'

export default {
}



// WEBPACK FOOTER //
// ./src/store/modules/gtm/getters.js